import React from 'react';
import PropTypes from 'prop-types';

import {Box, Typography} from 'views/components';
import {Translate} from 'views/module';

const JobNameView = (props) => {
  const {
    jobData,
    client,
  } = props;

  return (
    <Box>
      <Typography sx={{fontSize: '28px', fontWeight: 400}}>
        <Translate
          expression="career.jobDetail.Title"
          substitute={{
            clientName: client?.clientDetail?.clientName || jobData.client?.unregisteredClient || 'Unknown Client',
            neighborhood: jobData.location.neighborhood,
            city: jobData.location.city,
          }}
        />
      </Typography>
    </Box>
  );
};

JobNameView.propTypes = {
  jobData: PropTypes.object.isRequired,
  client: PropTypes.object,
};

export default React.memo(JobNameView);
